import { AxiosInstance } from 'axios';
import {
  PermissionGroup,
  Role,
  RoleWriteRequest,
} from '@/api/roles/roles.types.ts';

export const createRolesApi = (api: AxiosInstance) => ({
  getRoles: () => api.get<Role[]>('/v1/roles'),

  getPermissionCatalog: () =>
    api.get<PermissionGroup[]>('/v1/roles/permissions'),

  getRole: (id: string) => api.get<Role>(`/v1/roles/${id}`),

  createRole: (body: RoleWriteRequest) => api.post<Role>('/v1/roles', body),

  updateRole: (id: string, body: RoleWriteRequest) =>
    api.put<Role>(`/v1/roles/${id}`, body),

  deleteRole: (id: string) => api.delete<void>(`/v1/roles/${id}`),
});
